import dynamic                 from "next/dynamic";
import { useEffect, useState } from "react";

import { storeCTEvent }       from "_analytics/index";
import Toast                  from "_common/toast";
import {
	getLiveStreamMonitizationJourney,
	getPostMonitizationJourney
} from "_services/api/creator-dashboard";

import { getMigratedInitialMonetisationData } from "../earningOverview/utils";

const Presentation       = dynamic ( () => import ( "./presentation" ) );
const PresentationMobile = dynamic ( () => import ( "./presentationMobile" ) );

const updateMonetisationData = async ( type = "live" ) => {
	let callApi = ( type === "live" ) ? getLiveStreamMonitizationJourney : getPostMonitizationJourney;

	try {
		let response = await callApi ();

		return response;
	} catch ( e ) {
		Toast.e ( e.displayMsg );
	}

};

const component = props => {
	const {
		showStepperModal,
		toggleStepperModal,
		toggleFeedback,
		isMigratingData,
		isMobile,
		activeTabClicked
	} = props;

	if ( !showStepperModal )
		return null;

	const [ activeTab, setActiveTab ]               = useState ( activeTabClicked );
	const [ monetisationData, setMonetisationData ] = useState ( isMigratingData ? getMigratedInitialMonetisationData ( { type: activeTab } ) : null );

	const tabList = [
		{ label: "Live Streams", value: "live" },
		{ label: "Reels + Videos", value: "reels" }
	];

	useEffect ( () => {
		if ( isMigratingData )
			return;

		getMonetisationData ( activeTabClicked );
	}, [] );

	const onTabChange = async tab => {
		if ( isMigratingData ) {
			setActiveTab ( tab );

			return;
		}
		setActiveTab ( tab );
		const ctOptions = {
			eventProperty : "tab_clicked",
			value         : `${ activeTab === "live" ? "Live" : "Static" }_content`
		};

		storeCTEvent ( "creator_dashboard_navigation", ctOptions );
		getMonetisationData ( tab );

	};

	const getMonetisationData = async tab => {
		if ( isMigratingData )
			return;

		const data = await updateMonetisationData ( tab );

		setMonetisationData ( data );
	};

	if ( isMobile )
		return (
			<PresentationMobile
				activeTab          = { activeTab }
				monetisationSteps  = { monetisationData }
				onTabChange        = { onTabChange }
				showStepperModal   = { showStepperModal }
				tabList            = { tabList }
				toggleFeedback     = { toggleFeedback }
				toggleStepperModal = { toggleStepperModal }
			/>
		);

	return (
		<Presentation
			activeTab          = { activeTab }
			monetisationSteps  = { monetisationData }
			onTabChange        = { onTabChange }
			showStepperModal   = { showStepperModal }
			tabList            = { tabList }
			toggleFeedback     = { toggleFeedback }
			toggleStepperModal = { toggleStepperModal }
		/>
	);
};

export default component;